import { dbFirestore } from "../../firestore";

import type { TicketRedeemGroup } from "../../firestore/types";

export const fetchTicketRedeemGroups = async (): Promise<
  TicketRedeemGroup[]
> => {
  const snapshot = await dbFirestore.ticketRedeemGroups().get();
  return snapshot.docs.map((doc) => doc.data()).filter((data) => data !== null);
};
